import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen w-full flex items-center justify-center bg-[#FAFAF9]">
        <Loader2 className="w-5 h-5 animate-spin text-[#5F7368]" />
      </div>
    );
  }
  if (!user) return <Navigate to="/" replace />;
  return children;
}
